import React, { useContext, useEffect, useState } from "react";
import HeadingBanner from "../Components/HeadingBanner.jsx";
import Dashboard from "../Components/Dashboard.jsx";
import { Shimmer } from "react-shimmer";
import { GetWishlist_fun, RemoveWishlist_fun, MoveToCart_fun, RemoveAllWishlist_fun, MoveAllToCart_fun } from "../api/wishlist_api.js";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCount, setWishlistCount } from "../store/slices/counterSlice";
import instance from "../Config/Config.js";
import { Logindetail } from "../context/Logindetail.js";

const Wishlist = ({ settings }) => {
    const [wishlistData, setWishlistData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({
        title: "",
        message: "",
        icon: "",
        onConfirm: () => { }
    });
    const router = useNavigate();
    const dispatch = useDispatch();
    const { token } = useContext(Logindetail);

    const triggerConfirm = (config) => {
        setConfirmConfig(config);
        setShowConfirmModal(true);
    };

    const fetchWishlist = async () => {
        setIsLoading(true);
        try {
            const res = await GetWishlist_fun();
            setWishlistData(res?.data || []);
            dispatch(setWishlistCount(res?.data?.length || 0));
        } catch (error) {
            console.error("Error fetching wishlist:", error);
            toast.error("Failed to load wishlist");
        } finally {
            setIsLoading(false);
        }
    };

    const handleRemove = (productId) => {
        triggerConfirm({
            title: "Remove Item?",
            message: "Are you sure you want to remove this item from your wishlist?",
            icon: "🗑️",
            onConfirm: async () => {
                try {
                    const res = await RemoveWishlist_fun(productId);
                    if (res?.status === 200) {
                        toast.success("Removed from wishlist");
                        const newData = wishlistData.filter(item => item.product?.id !== productId);
                        setWishlistData(newData);
                        dispatch(setWishlistCount(newData.length));
                    } else {
                        toast.error(res?.message || "Failed to remove item");
                    }
                } catch (error) {
                    toast.error("Something went wrong");
                }
            }
        });
    };

    const handleMoveToCart = (productId) => {
        triggerConfirm({
            title: "Move to Cart?",
            message: "Are you sure you want to move this item to your cart?",
            icon: "🛒",
            onConfirm: async () => {
                try {
                    const res = await MoveToCart_fun(productId);
                    if (res?.status === 200) {
                        toast.success("Moved to cart");
                        const newData = wishlistData.filter(item => item.product?.id !== productId);
                        setWishlistData(newData);
                        dispatch(setWishlistCount(newData.length));

                        // Update cart count in redux
                        const responseApi = await instance.get(`get_cart_list`);
                        const itemCount = responseApi?.data?.carts?.length || 0;
                        dispatch(setCount(itemCount));
                    } else {
                        toast.error(res?.message || "Failed to move item");
                    }
                } catch (error) {
                    toast.error("Something went wrong");
                }
            }
        });
    };

    const handleRemoveAll = () => {
        triggerConfirm({
            title: "Clear Wishlist?",
            message: "Are you sure you want to clear your wishlist? This action cannot be undone.",
            icon: "🗑️",
            onConfirm: async () => {
                try {
                    const res = await RemoveAllWishlist_fun();
                    if (res?.status === 200) {
                        toast.success("Wishlist cleared");
                        setWishlistData([]);
                        dispatch(setWishlistCount(0));
                    } else {
                        toast.error(res?.message || "Failed to clear wishlist");
                    }
                } catch (error) {
                    toast.error("Something went wrong");
                }
            }
        });
    };

    const handleMoveAllToCart = () => {
        triggerConfirm({
            title: "Move All to Cart?",
            message: "Are you sure you want to move all items to your cart?",
            icon: "🛒",
            onConfirm: async () => {
                try {
                    const res = await MoveAllToCart_fun();
                    if (res?.status === 200) {
                        toast.success("All items moved to cart");
                        setWishlistData([]);
                        dispatch(setWishlistCount(0));

                        // Update cart count
                        const responseApi = await instance.get(`get_cart_list`);
                        const itemCount = responseApi?.data?.carts?.length || 0;
                        dispatch(setCount(itemCount));
                    } else {
                        toast.error(res?.message || "Failed to move items");
                    }
                } catch (error) {
                    toast.error("Something went wrong");
                }
            }
        });
    };

    const getImageUrl = (imagePath) => {
        if (!imagePath) return "/assets/images/placeholder_img.jfif";
        if (imagePath.startsWith("http")) return imagePath;
        // Construct base URL from REACT_APP_BASE_URL if needed
        const baseUrl = process.env.REACT_APP_BASE_URL.replace("/api/v1/", "/");
        return `${baseUrl}${imagePath}`;
    };

    useEffect(() => {
        if (!token) {
            // Redirect to home and open login popup
            router("/");
            setTimeout(() => {
                const trigger = document.getElementById("loginPopupopen");
                if (trigger) trigger.click();
            }, 100);
            return;
        }
        fetchWishlist();
    }, [token]);

    return (
        <>
            <HeadingBanner title={"My Wishlist"} />
            <section className="wishlist-page">
                <div className="container">
                    <div className="notifycation-layout">
                        <div className="row">
                            <div className="col-xl-3 col-lg-4 ">
                                <Dashboard setting_data={settings} />
                            </div>
                            <div className="col-xl-9 col-lg-8 ">
                                <div className="notifycation-content">
                                    <div className="notificatin-head pb-3 d-flex justify-content-between align-items-center">
                                        <h4>My Wishlist</h4>
                                        {wishlistData.length > 0 && (
                                            <div className="d-flex gap-2">
                                                <button className="btn btn-sm btn-outline-warning" onClick={handleMoveAllToCart}>Move All to Cart</button>
                                                <button className="btn btn-sm btn-outline-danger" onClick={handleRemoveAll}>Clear All</button>
                                            </div>
                                        )}
                                    </div>

                                    <div className="wishlist-items-container border py-4 px-md-4 px-2">
                                        {isLoading ? (
                                            <div className="row">
                                                {Array.from({ length: 4 }).map((_, i) => (
                                                    <div className="col-md-4 col-sm-6 mb-4" key={i}>
                                                        <Shimmer width={250} height={300} className="rounded" />
                                                    </div>
                                                ))}
                                            </div>
                                        ) : wishlistData.length > 0 ? (
                                            <div className="row">
                                                {wishlistData.map((item, i) => {
                                                    const product = item.product;
                                                    if (!product) return null;
                                                    
                                                    return (
                                                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4" key={i}>
                                                            <div className="card h-100 border rounded shadow-sm hover-shadow transition-all">
                                                                <div 
                                                                    className="wishlist-img-wrapper cursor-pointer" 
                                                                    onClick={() => router(`/detail/${product.slug}`, { state: { id: product.id } })}
                                                                    style={{ height: '200px', overflow: 'hidden' }}
                                                                >
                                                                    <img 
                                                                        src={getImageUrl(product.image)} 
                                                                        className="card-img-top img-fluid h-100 w-100 object-fit-contain p-2" 
                                                                        alt={product.name} 
                                                                    />
                                                                </div>
                                                                <div className="card-body d-flex flex-column text-center">
                                                                    <h5 className="card-title text-truncate" title={product.name}>{product.name}</h5>
                                                                    <div className="price-tag mb-3">
                                                                        {Number(product.before_discount) > 0 && (
                                                                            <span className="text-decoration-line-through text-muted me-2 small">
                                                                                ₹{Number(product.before_discount).toLocaleString('en-IN')}
                                                                            </span>
                                                                        )}
                                                                        <span className="fw-bold text-danger">
                                                                            ₹{Number(product.price).toLocaleString('en-IN')}
                                                                        </span>
                                                                    </div>
                                                                    <div className="mt-auto d-flex flex-column gap-2">
                                                                        <button 
                                                                            className="btn btn-warning btn-sm"
                                                                            onClick={() => handleMoveToCart(product.id)}
                                                                        >
                                                                            Move to Cart
                                                                        </button>
                                                                        <button 
                                                                            className="btn btn-outline-danger btn-sm"
                                                                            onClick={() => handleRemove(product.id)}
                                                                        >
                                                                            Remove
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <div className="text-center py-5">
                                                <div className="mb-4">
                                                    <img src="/assets/noData.png" alt="Empty Wishlist" style={{ maxWidth: '150px' }} />
                                                </div>
                                                <h4>Your wishlist is empty!</h4>
                                                <p className="text-muted">Start adding items you'd love to buy later.</p>
                                                <button 
                                                    className="btn btn-danger mt-3 px-4"
                                                    onClick={() => router('/gold-silver')}
                                                >
                                                    Explore Products
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showConfirmModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "12px",
                            padding: "32px 28px",
                            maxWidth: "380px",
                            width: "90%",
                            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
                            textAlign: "center",
                        }}
                    >
                        <div style={{ fontSize: "40px", marginBottom: "12px" }}>{confirmConfig.icon}</div>
                        <h5 style={{ fontWeight: 700, marginBottom: "8px", color: "#222" }}>
                            {confirmConfig.title}
                        </h5>
                        <p style={{ color: "#666", marginBottom: "24px", fontSize: "15px" }}>
                            {confirmConfig.message}
                        </p>
                        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                            <button
                                className="btn btn-warning fw-bold px-4"
                                onClick={async () => {
                                    setShowConfirmModal(false);
                                    await confirmConfig.onConfirm();
                                }}
                            >
                                Yes, Proceed
                            </button>
                            <button
                                className="btn btn-outline-secondary fw-bold px-4"
                                onClick={() => {
                                    setShowConfirmModal(false);
                                }}
                            >
                                No, Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Wishlist;
